export const colors = {
  gray: "#949494",
  almost_white: "#f0f0f0",
  almost_black: "#202020",
  white: "#fff",
  black: "#000",
};
